var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Skins/BoardGraphicStrings/index.js";
import React from 'react';
import pt from 'prop-types';
import { times, range } from 'ramda';
import { stringCenter, fretOffset } from './../../../../lib/fretboard';

const stringLine = ({nrOfStrings, selectedStrings}) => str => {
  const y = stringCenter(nrOfStrings)(str);
  if (selectedStrings == (str).toString()) {
      return /*#__PURE__*/React.createElement("line", {
        key: `str-${str}`,
        x1: "0%",
        x2: "100%",
        y1: `${y}%`,
        y2: `${y}%`,
        stroke: "red",
        strokeWidth: 3,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 10,
          columnNumber: 5
        }
      })
  } else {
      return /*#__PURE__*/React.createElement("line", {
        key: `str-${str}`,
        x1: "0%",
        x2: "100%",
        y1: `${y}%`,
        y2: `${y}%`,
        stroke: "black",
        strokeWidth: 1,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 26,
          columnNumber: 5
        }
      })
}};

const fretLineBounds = nrOfStrings => ({
  top: stringCenter(nrOfStrings)(0),
  bottom: stringCenter(nrOfStrings)(nrOfStrings - 1)
});

const fretLine = (nrOfFrets, nrOfStrings) => frt => {
  const {
    top,
    bottom
  } = fretLineBounds(nrOfStrings);
  const x = fretOffset(nrOfFrets)(frt);
  return /*#__PURE__*/React.createElement("line", {
    key: `fret-${frt}`,
    x1: `${x}%`,
    x2: `${x}%`,
    y1: `${top}%`,
    y2: `${bottom}%`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 5
    }
  });
};


const fretHighlightThing = ({fretHighlight, fretHighlightColor, nrOfStrings, nrOfFrets}) => frthi => {
  const {
    top,
    bottom
  } = fretLineBounds(nrOfStrings);
  if (fretHighlight.length < 2 || typeof(fretHighlight[0]) == 'undefined' || typeof(fretHighlight[1]) == 'undefined' )  {
    return
  }
  const x1 = fretOffset(nrOfFrets)(Math.max(fretHighlight[0]-1, 0));
  const x2 = fretOffset(nrOfFrets)(fretHighlight[1]);
  const width = x2 - x1
  const height = bottom-top
  return /*#__PURE__*/React.createElement("rect", {
    key: `fret-${frthi}`,
    x: `${x1}%`,
    width: `${width}%`,
    y: `${top}%`,
    height: `${height}%`,
    fill: "red",
    fillOpacity: "30%",
    //color: `${fretHighlightColor}`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 5
    }
  });
};

const BoardGraphicStrings = ({
  nrOfStrings,
  nrOfFrets,
  selectedStrings,
  fretHighlight,
  fretHighlightColor
}) => /*#__PURE__*/React.createElement("g", {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 40,
    columnNumber: 3
  }
}, 
times(stringLine({nrOfStrings, selectedStrings}), nrOfStrings), 
range(1, nrOfFrets).map(fretLine(nrOfFrets, nrOfStrings)),
times(fretHighlightThing({fretHighlight, fretHighlightColor, nrOfStrings, nrOfFrets}), 1) 
);

BoardGraphicStrings.propTypes = {
  nrOfStrings: pt.number.isRequired,
  nrOfFrets: pt.number.isRequired,
  selectedStrings: pt.arrayOf(pt.string).isRequired,
  fretHighlight: pt.arrayOf(pt.number).isRequired,
  fretHighlightColor: pt.string.isRequired
};

export default BoardGraphicStrings;
